import { FC, ReactNode } from 'react';

import styles from './List.module.scss';
type ListProps = {
  addClass?: string[];
  children: ReactNode;
};
export const List: FC<ListProps> = ({ children, addClass = [] }) => {
  return <ul className={[styles.list, ...addClass].join(' ')}>{children}</ul>;
};
